import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import {updateCode} from "../actions";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import CodeForm from './CodeForm';
import PropTypes from 'prop-types';
import {toast} from "react-toastify";

class CodeEditButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      updating: false,
      errors: {}
    }

    this.codeForm = React.createRef();
  }

  codeCreate(e, data) {
    e.preventDefault();
    this.setState({updating: true});

    this.props.updateCode({
      data: data.code,
      id: this.props.code.id
    }).then(() => {
      toast.success(<FormattedMessage id="admin.codeEditButton.toast.success" />);
      this.props.handleChange();
      this.setState({
        updating: false,
        modal: false
      })
    }).catch(e => {
      this.setState({
        updating: false,
        errors: e.response.data.form.errors
      });
    });
  }

  toggleModal(){
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    const { updating, errors } = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()} size="xl"
                         className={'modal-danger'}>
      <ModalHeader toggle={() => this.toggleModal()} tag="h2"><FormattedMessage id="admin.codeEditButton.modalHeader" /></ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <CodeForm errors={errors} onSubmit={this.codeCreate} ref={this.codeForm} code={this.props.code}/>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.save">{
          (message) => <LaddaButton
            className="btn btn-primary btn-ladda"
            loading={updating}
            data-style={ZOOM_OUT}
            onClick={e => this.codeCreate(e, this.codeForm.current.state)}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" onClick={() => this.toggleModal()}>{message}</Button>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Button color="primary" size="sm" onClick={() => this.toggleModal()}><i className="fas fa-edit" /> <FormattedMessage id="_.button.edit"/></Button>
        {modal}
      </React.Fragment>
    )
  }
}

CodeEditButton.propTypes = {
  code: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default connect(null, { updateCode }, null, {forwardRef: true})(CodeEditButton);